{
  "name": "@mmt/event-logger",
  "version": "4.6.0",
  "source": "src/index.ts",
  "types": "dist/index.d.ts",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "scripts": {
    "test": "jest",
    "lint": "eslint . --fix",
    "dev": "tsup src/index.ts --sourcemap --format esm,cjs --dts",
    "dev:watch": "tsup src/index.ts --sourcemap --format esm,cjs --dts --watch",
    "prepublishOnly": "yarn build",
    "build": "tsup src/index.ts --sourcemap --minify --format esm,cjs,iife --globalName MMTAnalyticsSDK",
    "build:umd": "tsup src/index.ts --sourcemap --minify --format iife --globalName MMTAnalyticsSDK",
    "build:watch": "tsup src/index.ts --sourcemap --minify --format esm,cjs,iife --globalName MMTAnalyticsSDK --watch",
    "clean": "rm -rf ./dist"
  },
  "dependencies": {
    "@mmt/events-schema": "2.1.0",
    "ua-parser-js": "^1.0.36",
    "uuid": "^9.0.0"
  },
  "peerDependencies": {
    "pako": "^2.1.0"
  },
  "devDependencies": {
    "@swc/core": "^1.3.95",
    "@types/pako": "^2.0.0",
    "@types/ua-parser-js": "^0.7.37",
    "jsdom": "^21.1.1",
    "parcel": "latest",
    "tsup": "^7.2.0"
  }
}
